export default "__VITE_ASSET__3ef32258__"